import { ReactNode } from 'react'
import styles from './components.module.css'

export function Card({
  children,
  className = '',
  style = {},
}: {
  children: string | ReactNode
  className?: string
  style?: object
}) {
  return (
    <div style={style} className={`${styles.card} ${styles[className]}`}>
      {children}
    </div>
  )
}
